import { IAnalytics, trackEventNext } from "@kunduz/utility-analytics";

function AuthEventsBuilder(): IAuthAnalytics {
  function activeCountryUpdated(payload: IAnalytics.StateUpdatedEvent) {
    trackEventNext({
      ...payload,
      event: "Active Country Updated",
    });
  }

  function appleAuthButtonClicked(payload: IAnalytics.ButtonEvent) {
    trackEventNext({
      ...payload,
      event: "Apple Auth Button Clicked",
    });
  }

  function googleAuthButtonClicked(payload: IAnalytics.ButtonEvent) {
    trackEventNext({
      ...payload,
      event: "Google Auth Button Clicked",
    });
  }

  function countryUpdateApprovalButtonClicked(payload: IAnalytics.ButtonEvent) {
    trackEventNext({
      ...payload,
      event: "Country Update Approval Button Clicked",
    });
  }

  function countryUpdateCancelButtonClicked(payload: IAnalytics.ButtonEvent) {
    trackEventNext({
      ...payload,
      event: "Country Update Cancel Button Clicked",
    });
  }

  function emailAuthButtonClicked(payload: IAnalytics.ButtonEvent) {
    trackEventNext({
      ...payload,
      event: "Email Auth Button Clicked",
    });
  }

  function emailSubmissionFailed(payload: IAnalytics.FormFailedEvent) {
    trackEventNext({
      ...payload,
      event: "Email Submission Failed",
    });
  }

  function emailSubmissionSucceeded(payload: IAnalytics.FormSuccessEvent) {
    trackEventNext({
      ...payload,
      event: "Email Submission Succeeded",
    });
  }

  function emailSubmitted(payload: IAnalytics.FormSubmittedEvent) {
    trackEventNext({
      ...payload,
      event: "Email Submitted",
    });
  }

  function loginButtonClicked(payload: IAnalytics.ButtonEvent) {
    trackEventNext({
      ...payload,
      event: "Login Button Clicked",
    });
  }

  function otpResendButtonClicked(payload: IAnalytics.ButtonEvent) {
    trackEventNext({
      ...payload,
      event: "OTP Resend Button Clicked",
    });
  }

  function otpSubmissionFailed(payload: IAnalytics.FormFailedEvent) {
    trackEventNext({
      ...payload,
      event: "OTP Submission Failed",
    });
  }

  function otpSubmissionSucceeded(payload: IAnalytics.FormSuccessEvent) {
    trackEventNext({
      ...payload,
      event: "OTP Submission Succeeded",
    });
  }

  function otpSubmitted(payload: IAnalytics.FormSubmittedEvent) {
    trackEventNext({
      ...payload,
      event: "OTP Submitted",
    });
  }

  function phoneNumberAuthButtonClicked(payload: IAnalytics.ButtonEvent) {
    trackEventNext({
      ...payload,
      event: "Phone Number Auth Button Clicked",
    });
  }

  function phoneNumberSubmissionFailed(payload: IAnalytics.FormFailedEvent) {
    trackEventNext({
      ...payload,
      event: "Phone Number Submission Failed",
    });
  }

  function phoneNumberSubmissionSucceeded(
    payload: IAnalytics.FormSuccessEvent,
  ) {
    trackEventNext({
      ...payload,
      event: "Phone Number Submission Succeeded",
    });
  }

  function phoneNumberSubmitted(payload: IAnalytics.FormSubmittedEvent) {
    trackEventNext({
      ...payload,
      event: "Phone Number Submitted",
    });
  }

  function signUpButtonClicked(payload: IAnalytics.ButtonEvent) {
    trackEventNext({
      ...payload,
      event: "Sign Up Button Clicked",
    });
  }

  function signUpFormSubmissionFailed(payload: IAnalytics.FormFailedEvent) {
    trackEventNext({
      ...payload,
      event: "Sign Up Form Submission Failed",
    });
  }

  function signUpFormSubmissionSucceeded(payload: IAnalytics.FormSuccessEvent) {
    trackEventNext({
      ...payload,
      event: "Sign Up Form Submission Succeeded",
    });
  }

  function signUpFormSubmitted(payload: IAnalytics.FormSubmittedEvent) {
    trackEventNext({
      ...payload,
      event: "Sign Up Form Submitted",
    });
  }

  function userNotFoundAlertViewed(payload: IAnalytics.AlertEvent) {
    trackEventNext({
      ...payload,
      event: "User Not Found Alert Viewed",
    });
  }

  function licenceCodeActivationFormSubmissionFailed(
    payload: IAnalytics.FormFailedEvent,
  ) {
    trackEventNext({
      ...payload,
      event: "Licence Code Activation Form Submission Failed",
    });
  }

  function licenceCodeActivationFormSubmissionSucceeded(
    payload: IAnalytics.FormSuccessEvent,
  ) {
    trackEventNext({
      ...payload,
      event: "Licence Code Activation Form Submission Succeeded",
    });
  }

  function licenceCodeActivationFormSubmitted(
    payload: IAnalytics.FormSubmittedEvent,
  ) {
    trackEventNext({
      ...payload,
      event: "Licence Code Activation Form Submitted",
    });
  }

  function licenceCodeSubmissionFailed(payload: IAnalytics.FormFailedEvent) {
    trackEventNext({
      ...payload,
      event: "Licence Code Submission Failed",
    });
  }

  function licenceCodeSubmissionSucceeded(
    payload: IAnalytics.FormSuccessEvent,
  ) {
    trackEventNext({
      ...payload,
      event: "Licence Code Submission Succeeded",
    });
  }

  function licenceCodeSubmitted(payload: IAnalytics.FormSubmittedEvent) {
    trackEventNext({
      ...payload,
      event: "Licence Code Submitted",
    });
  }

  function profileSelectionSubmitted(payload: IAnalytics.FormSubmittedEvent) {
    trackEventNext({
      ...payload,
      event: "Profile Selection Submitted",
    });
  }

  function usedLicenceCodeAlertViewed(payload: IAnalytics.AlertEvent) {
    trackEventNext({
      ...payload,
      event: "Used Licence Code Alert Viewed",
    });
  }

  return Object.freeze({
    activeCountryUpdated,
    appleAuthButtonClicked,
    googleAuthButtonClicked,
    countryUpdateApprovalButtonClicked,
    countryUpdateCancelButtonClicked,
    emailAuthButtonClicked,
    emailSubmissionFailed,
    emailSubmissionSucceeded,
    emailSubmitted,
    loginButtonClicked,
    otpResendButtonClicked,
    otpSubmissionFailed,
    otpSubmissionSucceeded,
    otpSubmitted,
    phoneNumberAuthButtonClicked,
    phoneNumberSubmissionFailed,
    phoneNumberSubmissionSucceeded,
    phoneNumberSubmitted,
    signUpButtonClicked,
    signUpFormSubmissionFailed,
    signUpFormSubmissionSucceeded,
    signUpFormSubmitted,
    userNotFoundAlertViewed,
    licenceCodeActivationFormSubmissionFailed,
    licenceCodeActivationFormSubmissionSucceeded,
    licenceCodeActivationFormSubmitted,
    licenceCodeSubmissionFailed,
    licenceCodeSubmissionSucceeded,
    licenceCodeSubmitted,
    profileSelectionSubmitted,
    usedLicenceCodeAlertViewed,
  });
}

export const AuthEvents = AuthEventsBuilder();

interface IAuthAnalytics {
  activeCountryUpdated: (payload: IAnalytics.StateUpdatedEvent) => void;
  appleAuthButtonClicked: (payload: IAnalytics.ButtonEvent) => void;
  googleAuthButtonClicked: (payload: IAnalytics.ButtonEvent) => void;
  countryUpdateApprovalButtonClicked: (payload: IAnalytics.ButtonEvent) => void;
  countryUpdateCancelButtonClicked: (payload: IAnalytics.ButtonEvent) => void;
  emailAuthButtonClicked: (payload: IAnalytics.ButtonEvent) => void;
  emailSubmissionFailed: (payload: IAnalytics.FormFailedEvent) => void;
  emailSubmissionSucceeded: (payload: IAnalytics.FormSuccessEvent) => void;
  emailSubmitted: (payload: IAnalytics.FormSubmittedEvent) => void;
  loginButtonClicked: (payload: IAnalytics.ButtonEvent) => void;
  otpResendButtonClicked: (payload: IAnalytics.ButtonEvent) => void;
  otpSubmissionFailed: (payload: IAnalytics.FormFailedEvent) => void;
  otpSubmissionSucceeded: (payload: IAnalytics.FormSuccessEvent) => void;
  otpSubmitted: (payload: IAnalytics.FormSubmittedEvent) => void;
  phoneNumberAuthButtonClicked: (payload: IAnalytics.ButtonEvent) => void;
  phoneNumberSubmissionFailed: (payload: IAnalytics.FormFailedEvent) => void;
  phoneNumberSubmissionSucceeded: (
    payload: IAnalytics.FormSuccessEvent,
  ) => void;
  phoneNumberSubmitted: (payload: IAnalytics.FormSubmittedEvent) => void;
  signUpButtonClicked: (payload: IAnalytics.ButtonEvent) => void;
  signUpFormSubmissionFailed: (payload: IAnalytics.FormFailedEvent) => void;
  signUpFormSubmissionSucceeded: (payload: IAnalytics.FormSuccessEvent) => void;
  signUpFormSubmitted: (payload: IAnalytics.FormSubmittedEvent) => void;
  userNotFoundAlertViewed: (payload: IAnalytics.AlertEvent) => void;
  licenceCodeActivationFormSubmissionFailed: (
    payload: IAnalytics.FormFailedEvent,
  ) => void;
  licenceCodeActivationFormSubmissionSucceeded: (
    payload: IAnalytics.FormSuccessEvent,
  ) => void;
  licenceCodeActivationFormSubmitted: (
    payload: IAnalytics.FormSubmittedEvent,
  ) => void;
  licenceCodeSubmissionFailed: (payload: IAnalytics.FormFailedEvent) => void;
  licenceCodeSubmissionSucceeded: (
    payload: IAnalytics.FormSuccessEvent,
  ) => void;
  licenceCodeSubmitted: (payload: IAnalytics.FormSubmittedEvent) => void;
  profileSelectionSubmitted: (payload: IAnalytics.FormSubmittedEvent) => void;
  usedLicenceCodeAlertViewed: (payload: IAnalytics.AlertEvent) => void;
}
